var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Wave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 446,
    viewBox: "0 0 1440 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 196.885L20 174.951C40 151.972 80 107.059 120 114.371C160 121.682 200 144.661 240 144.661C280 144.661 300.117 135.789 321.5 103.405C342.883 71.0211 367.5 38.1371 416.5 25.5967C465.5 13.0562 528 113.144 579.5 135.789C631 158.435 709 96.1002 755 74.6815C801 53.2628 806.5 93.4824 852 83.0375C897.5 72.5925 917 25.5967 960 39.168C1003 52.7394 1040 137.349 1080 144.661C1120 151.972 1160 92.4365 1200 39.168C1240 -13.056 1280 -13.056 1320 39.168C1360 91.392 1400 167.639 1420 227.175L1440 287.754V446H1420C1400 446 1360 446 1320 446C1280 446 1240 446 1200 446C1160 446 1120 446 1080 446C1040 446 1000 446 960 446C920 446 880 446 840 446C800 446 760 446 720 446C680 446 640 446 600 446C560 446 520 446 480 446C440 446 400 446 360 446C320 446 280 446 240 446C200 446 160 446 120 446C80 446 40 446 20 446H0V196.885Z",
    fill: "url(#paint0_linear_611_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_4",
    x1: 720,
    y1: -22.9706,
    x2: 720,
    y2: 513.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008080",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Wave);
export default __webpack_public_path__ + "static/media/2wave.5d1fe3717ddf01bfddae81cb18cf8240.svg";
export { ForwardRef as ReactComponent };